import { render, staticRenderFns } from "./RelatorioPedidosListFiltroModalItem.vue?vue&type=template&id=6fcb0612"
import script from "./RelatorioPedidosListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidosListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports